'use strict';

import React from "react";
import PropTypes from 'prop-types';
import classnames from "classnames";

import {ExtraordinaryCircumstancesQuarters} from '../lib/Constants';

const ExtraordinaryCircumstances = ({termId, className, show = false}) => {
    let component = null;
    if (ExtraordinaryCircumstancesQuarters.includes(termId) || show) {
        component =
            <small className={classnames('d-block fw-bold text-center mt-2', className)}>
                Extraordinary Circumstances Quarter
            </small>;
    }

    return component;
}

ExtraordinaryCircumstances.propTypes = {
    termId: PropTypes.string.isRequired, // The termId of term being displayed by parent component
    className: PropTypes.string, // CSS classes to apply to the text (mostly for current term which is white on purple background)
    show: PropTypes.bool // Boolean whether to show label, would override the term id check, if needed
}

export default ExtraordinaryCircumstances;